<template>
  <div class="card border-radius-none">
    <div class="columns is-marginless is-paddingless is-multiline card-article">
      <div class="column is-12 is-paddingless">
        <div v-if="!ligneCommande.referencePersonnalise"
          class="card-article-input-icon">
          &nbsp;
        </div>
        <div v-else class="card-article-input-icon">
          <b-icon
            class="mgt-25px has-text-primary mgl-20px"
            icon="subdirectory-arrow-right">
          </b-icon>
        </div>
        <div class="card-article-input-product-large mgb-10px mgt-10px">
          <b-field :label="$t('detail.article.product')"
                   custom-class="is-size-7 is-marginless has-text-link">
            <span>{{ ligneCommande.produit.reference }}</span>
          </b-field>
        </div>
        <div class="card-article-input-libelle-remise mgb-10px">
          <b-field custom-class="is-size-7 is-marginless has-text-link"
                   :label="$t('detail.article.libelle')">
            <span >{{ ligneCommande.libelle }}
            </span>
          </b-field>
        </div>

        <div class="general-article"
             v-if="estProduitNumerique">
          <b-field :label="$t('detail.article.saturation')"
                   custom-class="is-size-7 is-marginless has-text-link">
            <div class="columns is-marginless is-vcentered">
              <span class="column is-narrow has-text-link is-size-6 is-paddingless mgr-5px">
                {{$t('detail.article.saturationLabel')}}
              </span>
              <span>{{ saturation }}</span>
            </div>
          </b-field>
        </div>
        <div class="card-article-input-date mgt-14px has-text-icon-more is-size-7"
             v-if="dateOrMessage">
          {{ dateOrMessage }}
        </div>
        <div class="float-right mgt-25px mgr-20px">
          <a @click="openDetail = !openDetail" class="iconArrowMenu"
             :class="{'iconRecouvrementArrowMenuOpen': openDetail}">
            <b-icon
              icon="arrow-right-drop-circle"
              type="is-default"
            >
            </b-icon>
          </a>
        </div>
        <div class="has-text-weight-semibold mgt-28px float-right
          card-article-input-price-general right">
          <span v-if="ligneCommande.totalHt">
            {{ligneCommande.totalHt | formatDevise}}
          </span>
          <span v-else> {{ 0.00 | formatDevise }} </span>
        </div>
      </div>
      <div class="column is-12 is-paddingless">
        <qd-collapse :open="openDetail" animation="slide-fade">
          <hr class="is-marginless"/>
          <div v-for="(ligne, $index) in ligneCommande.lignesCommande" :key="$index">
            <app-ligne-normale v-if="ligne.type !== typeCommentaire"
                               class="has-background-table-second-color"
                               :sens="sens"
                               :societe-id="societeId"
                               :ligneCommande="ligne"
                               :sousLigne="true"
                               :typeProduit="ligneCommande.typeProduit"
                               :ligneRegroupement="ligneCommande"
            />
          </div>
        </qd-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import * as devisConf from '@/configuration/devisConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import formatDate from '@/services/general/formatDate';
import * as saturationConvertisseur from '@/services/devisCommandes/numerique/saturationConvertisseur';
import appLigneNormale from './ligneCommandeProduitNormal';

export default {
  name: 'ligneRegroupementProduit',
  props: {
    ligneCommande: Object,
    sens: {
      type: String,
      required: true,
    },
    societeId: {
      type: String,
      required: true,
    },
  },
  components: {
    appLigneNormale,
  },
  data() {
    return {
      typeCommentaire: devisConf.COMMENTAIRE,
      openDetail: true,
      saturation: null,
    };
  },
  mounted() {
    if (this.estProduitNumerique) {
      this.saturation = saturationConvertisseur.toSaturation(this.ligneCommande.quantiteDispo);
    }
    this.openDetail = this.isOpened;
  },
  computed: {
    dateOrMessage() {
      switch (this.ligneCommande.typeProduit) {
        case produitConf.CATEGORIE_UNITAIRE:
          return this.getDateUnitaire;
        case produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE:
        case produitConf.CATEGORIE_ECRAN_NUMERIQUE:
        case produitConf.CATEGORIE_REGROUPEMENT_LC:
          return this.getDateGeneral;
        default: return null;
      }
    },
    isOpened() {
      const nombreProduitVide = this.ligneCommande.lignesCommande.filter(
        l => !l.produitId,
      ).length;
      return nombreProduitVide > 0;
    },
    getDateUnitaire() {
      if (this.ligneCommande.dateDebut && this.ligneCommande.dateFin) {
        return this.$t('detail.article.date', { dateDebut: formatDate(this.ligneCommande.dateDebut), dateFin: formatDate(this.ligneCommande.dateFin) });
      }
      return this.$t('dateDevis.pasDate');
    },
    getDateGeneral() {
      if (!this.ligneCommande.dateDebut) return this.$t('dateDevis.pasDate');
      if (!this.ligneCommande.dateFin) {
        return this.$t('detail.article.dateDebut', { dateDebut: formatDate(this.ligneCommande.dateDebut) });
      }
      return this.$t('detail.article.date', { dateDebut: formatDate(this.ligneCommande.dateDebut), dateFin: formatDate(this.ligneCommande.dateFin) });
    },
    estProduitNumerique() {
      return this.ligneCommande.typeProduit === produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE
        || this.ligneCommande.typeProduit === produitConf.CATEGORIE_ECRAN_NUMERIQUE;
    },
  },
  methods: {

  },
};
</script>
